import React, { useState, useEffect } from "react";
import { Modal, Image } from "antd";
import { useSelector } from "react-redux";
import Api, { authUser } from "../../../../services/ServiceApi";
import Cookies from "js-cookie";
import Renderbtn from "../../../../pages/uih/wf_controllers/BtnController/renderButton";
import { FormatDateTime, TotalTime } from "../../../utility/format";
import { BadgePill } from "../../../badge_pill/badge_pill";
import ApproveProcessModal from "../../../approve_process/approve_process_modal";
import ApproveProcessLogModal from "../../../approve_process/approve_process_log_modal";
import DynamicLabelGroup from "../../../dynamic_label/dynamic_label_group";
// import ApproveProcessLog from "../../../approve_process/approve_process_log";
function Stoptimecard({
  data,
  language = null,
  factupdate = false,
  seteditMode,
  setinitEditData,
  showBtn,
  pic = null,
}) {
  const {
    job_stop_start,
    job_stop_end,
    progress_type_Detail,
    job_stop_reason,
    job_stop_remark,
    total_days,
    total_hour,
    total_min,
    approve_status_id,
    approve_id,
    approve_status_name,
    last_approve_level_seq,
    approve_config_desc,
    approve_status_bgcolor,
    approve_status_color,
    job_id,
    data_dynamic,
    job_edit_time_remark,
    edit_stop_start,
    edit_stop_end,
  } = data;

  console.log("data kuyyyyy",data)
  const locale = Cookies.get("locale");
  const [showApproveProcessLog, setshowApproveProcessLog] = useState(false);
  const [showApprove, setshowApprove] = useState(false);
  const [showApprveDes, setshowApprveDes] = useState(false);
  const [sendData, setsendData] = useState(null);
  const { masterLang, factUpdate } = useSelector((state) => state.masterLang);
  const OpenModal = (type) => {
    switch (type) {
      case "edit":
        seteditMode(true);
        setinitEditData(data);
        break;
      case "delete":
        break;
      default:
        return null;
    }
  };
  const openViewLogModal = () => {
    setshowApproveProcessLog(true);
  };
  const openViewApprove = (item) => {
    setsendData(item);
    setshowApprove(true);
  };
  const openApproveDes = () => {
    setshowApprveDes(true);
  };
  const approveLogCallBack = () => {
    setshowApproveProcessLog(false);
  };
  const approveFormCallBack = () => {
    setshowApprove(false);
    window.location.reload();
  };
  return (
    <>
      <div className={`card-body p-3`}>
        <div className="card-text">
          {showBtn ? (
            <div className="d-flex align-items-center justify-content-end flex-wrap py-1">
              <Renderbtn
                renderBtn={{
                  visible: true,
                  html_tag: "button",
                  type: "Text",
                  text: "Edit",
                  // image_path: "/icon/bbtec/button/sm/edit.svg",
                  css: "btn btn-xs btn-warning",
                }}
                btnMiddleware={OpenModal}
                index="edit_btn_stoptime"
                item="edit"
                disable={false}
              ></Renderbtn>
              {/* <Renderbtn
                renderBtn={{
                  visible: true,
                  html_tag: "button",
                  type: "Image",
                  image_path: "/icon/bbtec/button/sm/delete.svg",
                  css: "btn btn-xs",
                }}
                btnMiddleware={OpenModal}
                index="delete_btn_stoptime"
                item="delete"
                disable={false}
              ></Renderbtn> */}
            </div>
          ) : null}

          <div className="">
            <div className="row">
              <span className="col col-4 content-label c-red">
                {factupdate
                  ? language[locale]["start_count_stop_time"]
                  : "Stop Time"}
              </span>
              <span className="col col-8 content-text c-red">
                <FormatDateTime text={job_stop_start}></FormatDateTime>
              </span>
            </div>
            <div className="row">
              <span className="col col-4 content-label c-green">
                {factupdate
                  ? language[locale]["start_count_start_time"]
                  : `Start Time`}
              </span>
              <span className="col col-8 content-text c-green">
                {job_stop_end === null ? (
                  <span>ไม่พบข้อมูล Start time</span>
                ) : (
                  <FormatDateTime text={job_stop_end}></FormatDateTime>
                )}
              </span>
            </div>
            <div className="row">
              <span className="col col-4 content-label">
                {factupdate ? language[locale]["total_time"] : `Total Time`}
              </span>
              <span className="col col-8 content-text">
                <TotalTime
                  days={total_days}
                  hour={total_hour}
                  min={total_min}
                ></TotalTime>
              </span>
            </div>
            {edit_stop_start && (
              <div className="row">
                <span className="col col-4 content-label c-yellow">
                  Edit Stop Time
                </span>
                <span className="col col-8 content-text c-yellow">
                  <FormatDateTime text={edit_stop_start} />
                </span>
              </div>
            )}
            {edit_stop_end && (
              <div className="row">
                <span className="col col-4 content-label c-green">
                  Edit Start Time
                </span>
                <span className="col col-8 content-text c-green">
                  <FormatDateTime text={edit_stop_end} />
                </span>
              </div>
            )}
            <div className="row">
              <span className="col col-4 content-label">
                {factupdate
                  ? language[locale]["progress_detail"]
                  : `Progress Detail`}
              </span>
              <span className="col col-8 content-text">
                {progress_type_Detail}
              </span>
            </div>
            <div className="row">
              <span className="col col-4 content-label">
                {factupdate ? language[locale]["reason"] : `Reason`}
              </span>
              <span className="col col-8 content-text">{job_stop_reason}</span>
            </div>
            <div className="row">
              <span className="col col-4 content-label">
                {factupdate ? language[locale]["remark"] : `Remark`}
              </span>
              <span className="col col-8 content-text">{job_stop_remark}</span>
            </div>
            {job_edit_time_remark && (
              <div className="row">
                <span className="col col-4 content-label">Remark Edit</span>
                <span className="col col-8 content-text">
                  {job_edit_time_remark}
                </span>
              </div>
            )}

            {approve_status_id ? (
              <>
                <div className="row align-items-center">
                  <span className="col col-4 content-label">
                    {factupdate ? language[locale]["approve_status"] : `Status`}
                  </span>
                  <span className="col col-8 content-text">
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => openApproveDes()}
                    >
                      <BadgePill
                        bgColor={approve_status_bgcolor}
                        color={approve_status_color}
                        text={`${approve_status_name} Level: ${last_approve_level_seq}`}
                      ></BadgePill>
                    </span>
                    <Renderbtn
                      renderBtn={{
                        visible: true,
                        html_tag: "button",
                        type: "FA",
                        // image_path: "/icon/bbtec/button/sm/view-detail.svg",
                        font_awasome: "fas fa-history",
                        css: "btn btn-xs btn-light",
                      }}
                      btnMiddleware={openViewLogModal}
                      index="view_btn_stoptime"
                      item={{
                        approve_id: approve_id,
                      }}
                      disable={false}
                    ></Renderbtn>
                    {Number(approve_status_id) > 2 ? (
                      <Renderbtn
                        renderBtn={{
                          visible: true,
                          html_tag: "button",
                          type: "FA",
                          // image_path: "/icon/bbtec/button/md/approve.svg",
                          font_awasome: "far fa-check-square",
                          css: "btn btn-xs btn-light",
                        }}
                        btnMiddleware={openViewApprove}
                        index="view_btn_stoptime"
                        item={{
                          approve_id: approve_id,
                          last_approve_level_seq: last_approve_level_seq,
                          job_id: job_id,
                          data_dynamic: data_dynamic,
                        }}
                        disable={false}
                      ></Renderbtn>
                    ) : null}
                  </span>
                </div>
              </>
            ) : null}
            {pic?.length > 0 ? (
              <div className="row">
                <div className="mr-4 mt-2" style={{ cursor: "pointer" }}>
                  <Image.PreviewGroup>
                    {pic?.map((s, i) => (
                      <Image
                        key={`stop_time_picture_index_${i}`}
                        width={150}
                        height={80}
                        src={Api.checkPath(s.pic_url_path, s.pic_upload_name)}
                      ></Image>
                    ))}
                  </Image.PreviewGroup>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {showApproveProcessLog ? (
        <ApproveProcessLogModal
          visible={showApproveProcessLog}
          callbackFunction={approveLogCallBack}
          sendData={{ approve_id: approve_id }}
          wrapClassName="bbtec-theme"
        ></ApproveProcessLogModal>
      ) : null}
      {showApprove ? (
        <ApproveProcessModal
          visible={showApprove}
          callbackFunction={approveFormCallBack}
          sendData={sendData ? sendData : null}
        ></ApproveProcessModal>
      ) : null}
      {showApprveDes ? (
        <Modal
          title={<h4>Approve Description</h4>}
          footer={null}
          visible={showApprveDes}
          wrapClassName={"bbtec-theme"}
          onCancel={() => setshowApprveDes(false)}
        >
          <DynamicLabelGroup
            data={approve_config_desc}
            groupHeader={false}
            language={masterLang}
            factupdate={factUpdate}
            locale={locale}
            wrapClassname={"bbtec-theme"}
          ></DynamicLabelGroup>
        </Modal>
      ) : null}
    </>
  );
}
export function StopTimeDetailModal({
  title = "Stop Time Detail",
  modalOpen,
  setmodalOpen,
  sendData,
  language,
  factupdate,
  wrapClassName = "bbtec-theme",
  mode = "modal",
}) {
  const [stoptimeList, setstoptimeList] = useState([]);
  const [stopTimePic, setstopTimePic] = useState([]);
  const auth = authUser();
  useEffect(() => {
    Api.post("job_detail/stoptime_detail", {
      job_stop_id: sendData.job_stop_id,
      company_id: auth.companyId,
      operator_id: auth.operatorId,
      project_id: auth.projectId,
    }).then((res) => {
      const { result, data } = res.data;
      if (result.code === "P") {
        const mapList = data.result_stop_time?.map((s) => ({
          job_stop_id: s.job_stop_id,
          job_stop_start: s.job_stop_start,
          job_stop_end: s.job_stop_end,
          total_days: s.total_days,
          total_hour: s.total_hour,
          total_min: s.total_min,
          progress_type_Detail: s.progress_type_Detail,
          job_stop_reason: s.job_stop_reason,
          job_stop_remark: s.job_stop_remark,
          edit_stop_start : s.edit_stop_start,
          edit_stop_end : s.edit_stop_end,
        }));
        setstoptimeList(mapList);
        setstopTimePic(data?.result_oper_pic);
      }
    });
  }, []);
  return (
    <>
      {mode === "modal" ? (
        <Modal
          title={
            <>
              <img
                src={Api.absoluteUrl(`/icon/stop_time.svg`)}
                alt={title}
                title={title}
              />
              <h4>{title}</h4>
            </>
          }
          footer={null}
          visible={modalOpen}
          centered
          onCancel={() => setmodalOpen(false)}
          wrapClassName={wrapClassName}
        >
          {stoptimeList?.map((s, i) => (
            <Stoptimecard
              data={s}
              pic={stopTimePic?.filter(
                (m) => m.pic_type === "T" && m.reference_id === s.job_stop_id
              )}
              key={`stop_time_card_index${i}`}
              language={language}
              factupdate={factupdate}
            ></Stoptimecard>
          ))}
        </Modal>
      ) : (
        <>
          {stoptimeList?.map((s, i) => (
            <Stoptimecard
              data={s}
              pic={stopTimePic?.filter(
                (m) => m.pic_type === "T" && m.reference_id === s.job_stop_id
              )}
              key={`stop_time_card_index${i}`}
              language={language}
              factupdate={factupdate}
            ></Stoptimecard>
          ))}
        </>
      )}
    </>
  );
}

export default Stoptimecard;
